import { constant, Decoder, number, object, string, union } from '@mojotech/json-type-validation'

import { ArenaUserEntry } from '@/domain/entities/arena/arenaUserEntry'

export const arenaUserEntryDecoder: Decoder<ArenaUserEntry> = object({
  userId: string(),
  arenaId: string(),
  country: string(),
  affiliation: union(string(), constant(null)),
  entryDate: number().map(x => new Date(x))
})
